import { render, staticRenderFns } from "./InclusaoOcorrenciaForm.vue?vue&type=template&id=69624597"
import script from "./InclusaoOcorrenciaForm.vue?vue&type=script&lang=js"
export * from "./InclusaoOcorrenciaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports